import { useState } from "react";
import { Modal } from "react-bootstrap";

import { printLabels } from "components/Apis/warehouse";


export const LabelPrinter = ({ orders }) => {
    const [showModal, setShowModal] = useState(false);
    const [printingOrders, setPrintingOrders] = useState(orders.map((order) => ({ id: order.id })));

    const handlePrint = () => {
        setShowModal(false);
        printLabels(printingOrders)
    };

    return (
        <>
            <button
                className='btn btn-primary m-1 px-2 py-1 print-labels-icon-btn'
                onClick={(e) => setShowModal(true)}
                title='Print Labels'
            >
                <i className='fa fa-file' />
            </button>
            <Modal className="warehouse-modal" show={showModal}>
                <Modal.Header>
                    <Modal.Title>Print Labels</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ wordWrap: "break-word" }}>
                    <table className='table'>
                        <thead style={{ fontWeight: "bold" }}>
                            <tr>
                                <th style={{ width: '12%' }}>Order</th>
                                <th style={{ width: '12%' }}>Outbond</th>
                                <th style={{ width: '12%' }}>Units</th>
                                <th>Delivery Address</th>
                                <th style={{ width: '12%' }}>Print Range</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.map((order) => (
                                <tr key={order.id}>
                                    <td>{order.order_no}</td>
                                    <td>{order.outgoing_bus?.name ?? order.bus}</td>
                                    <td>{order.units}</td>
                                    <td>
                                        <input
                                            type="text"
                                            className="input small thin"
                                            defaultValue={`${order.deliver_address}, ${order.delivery_city_state} ${order.deliver_zip}`}
                                            onChange={(e) =>
                                                setPrintingOrders((prev) =>
                                                    prev.map((o) =>
                                                        o.id === order.id
                                                            ? { ...o, address: e.target.value }
                                                            : o
                                                    )
                                                )
                                            }
                                        />
                                    </td>
                                    <td>
                                        <input
                                            defaultValue={`1-${order.units}`}
                                            className="input small thin"
                                            onChange={(e) =>
                                                setPrintingOrders((prev) =>
                                                    prev.map((o) =>
                                                        o.id === order.id
                                                            ? { ...o, printRange: e.target.value }
                                                            : o
                                                    )
                                                )
                                            }
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <button className="modal-action-button non-acting" variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </button>
                    <button
                        className="modal-action-button decicive"
                        variant="primary"
                        onClick={handlePrint}
                    >
                        Print
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};